<template>
  <main class="my-4">
    <div class="grid-container">
      <div class="section-header section-header--dividing section-header--xl mt-3">
        <h1 class="heading" v-html="getBaseProperty('basepropBulkorderUpload')"></h1>
        <div class="buttons">
          <trek-link id="bulkOrderDownloadButton" button secondary small icon="get_app" :href="downloadtemplateUrl">
            <span v-html="getBaseProperty('basepropBulkorderTemplate')"></span>
          </trek-link>
        </div>
      </div>

      <div v-show="!postUploadState" class="section pt-3">
        <file-upload
          button-id="bulkOrderFileUploadButton"
          input-id="bulk-upload-file"
          accept="text/csv"
          extensions="csv"
          :click-to-upload-msg="getBaseProperty('basepropClicktoupload')"
          :wrong-file-type-msg="getBaseProperty('basepropWrongExtension')"
          :csrf-token="token"
          aspect-ratio="4"
          @response="setDataAsResponse"
          @activate-upload="startLoadingIndicator"
        >
          <template slot="help">
            {{ getBaseProperty('basepropBulkorderFileformat') }}
          </template>
        </file-upload>
      </div>

      <div v-show="failureLinesList.length > 0 && postUploadState" qaid="bulk-upload-failure-list">
        <p class="mt-3">
          {{ getBaseProperty('basepropBulkorderFailed') }}
        </p>
        <table class="b2b-grid b2b-grid--collapse is-compact" qaid="bulk-upload-failure-table">
          <thead class="b2b-grid__header">
            <tr>
              <th class="b2b-grid__cell b2b-grid__head">
                {{ getBaseProperty('basepropBulkorderSku') }}
              </th>
              <th class="b2b-grid__cell b2b-grid__head">
                {{ getBaseProperty('basepropBulkorderItem') }}
              </th>
              <th class="b2b-grid__cell b2b-grid__head">
                {{ getBaseProperty('basepropBulkorderQty') }}
              </th>
              <th class="b2b-grid__cell b2b-grid__head">
                {{ getBaseProperty('basepropBulkorderIssue') }}
              </th>
            </tr>
          </thead>

          <tbody>
            <!-- Parse failure messages -->
            <tr v-for="(row, index) in failureLinesList" :key="`${row.sku}-${index}`" class="table-row">
              <td class="b2b-grid__cell lg:table-cell">
                <div class="b2b-grid__label">
                  {{ getBaseProperty('basepropBulkorderSku') }}
                </div>
                <div class="b2b-grid__content">
                  {{ row.sku }}
                </div>
              </td>
              <td class="b2b-grid__cell lg:table-cell">
                <div class="b2b-grid__label">
                  {{ getBaseProperty('basepropBulkorderItem') }}
                </div>
                <div class="b2b-grid__content">
                  {{ row.itemName }}
                </div>
              </td>
              <td class="b2b-grid__cell lg:table-cell">
                <div class="b2b-grid__label">
                  {{ getBaseProperty('basepropBulkorderQty') }}
                </div>
                <div class="b2b-grid__content">
                  {{ row.qty }}
                </div>
              </td>
              <td class="b2b-grid__cell lg:table-cell">
                <div class="b2b-grid__label">
                  {{ getBaseProperty('basepropBulkorderIssue') }}
                </div>
                <div class="b2b-grid__content">
                  <div class="flex items-center lg:justify-start">
                    <i class="md-18 text-alert mr-25">error</i>
                    {{ row.issue }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-show="postUploadState" class="buttons buttons--right-for-md">
        <trek-link button primary :href="cartpageUrl">
          <span v-html="getBaseProperty('basepropBulkorderCartview')"></span>
        </trek-link>
        <trek-button secondary @click="startAnotherUpload">
          <span v-html="getBaseProperty('basepropBulkorderUploadanother')"></span>
        </trek-button>
      </div>
      <trek-loading page :is-loading="loadingIndicator" />
    </div>
  </main>
</template>

<script>
import {mapActions} from 'vuex';
import find from 'lodash/find';
import TrekLink from '@/components/TrekLink';
import TrekButton from '@/components/TrekButton';
import FileUpload from '@/components/FileUpload';
import TrekLoading from '@/components/TrekLoading';

export default {
  components: {TrekLink, TrekButton, FileUpload, TrekLoading},
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    downloadtemplateUrl: {
      type: String,
      default: undefined,
    },
    cartpageUrl: {
      type: String,
      default: undefined,
    },
    token: {
      type: String,
      default: undefined,
    },
  },

  data() {
    return {
      loadingIndicator: false,
      uploadedFile: {},
      failureLinesList: [],
      postUpload: false,
    };
  },

  computed: {
    postUploadState() {
      return this.postUpload;
    },
  },

  methods: {
    getBaseProperty(name) {
      let baseProperty = find(this.baseProperties, (baseProperty) => baseProperty.name === name);
      return baseProperty ? baseProperty.label : '';
    },
    setDataAsResponse(response) {
      this.loadingIndicator = false;
      this.failureLinesList = response.failureLinesList;
      this.postUpload = true;
      this.fetchMiniCart();
    },

    startAnotherUpload() {
      this.postUpload = false;
    },

    startLoadingIndicator() {
      this.loadingIndicator = true;
    },
    ...mapActions('miniCart', ['fetchMiniCart']),
  },
};
</script>
